/*
  Norvela — koppelt de kleurkeuze aan de bijbehorende foto in de galerij.

  Waarom dit bestaat: Shopify wisselt normaal alleen van beeld als je per variant
  media koppelt in de beheeromgeving. Met vier maten x zes kleuren zijn dat
  24 koppelingen, en zodra er eentje mist gebeurt er niets.

  Dit script koppelt op naam. Het kijkt per foto naar de ALT-tekst en naar de
  BESTANDSNAAM in de afbeeldings-URL. De kleurfoto's heten "kleur 1 saliegroen",
  "kleur 3 blauw" enzovoort; het script gooit "kleur" en de cijfers weg en houdt
  "saliegroen" of "blauw" over. Dat vergelijkt het in beide richtingen met de
  gekozen optiewaarde, zodat "Marineblauw" ook op "blauw" matcht.

  Het werkt op twee manieren, zodat het ook op mobiel doet wat het moet:
    - staat er een miniatuurbalk (desktop), dan klikt het de juiste miniatuur
    - anders schuift het de juiste dia zelf in beeld

  Koppelt Annemarie later alsnog media aan varianten, dan doet Shopify het zelf
  en heeft dit script simpelweg niets meer te doen.
*/
(function () {
  'use strict';

  var OPTIE = /kleur|colour|color/i;
  var RUIS = /(kleur|colour|color|foto|photo|image|img|norvela|deken|blanket|png|jpg|jpeg|webp|copy|final|\d+)/g;

  function normaliseer(tekst) {
    return (tekst || '')
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '');
  }

  function kleurwoorden(bron) {
    if (!bron) return [];
    var schoon = String(bron)
      .split('?')[0]
      .split(' ')[0]
      .split('/')
      .pop()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(RUIS, ' ');
    return schoon.split(' ').filter(function (w) {
      return w.length >= 4;
    });
  }

  function past(kleur, bron) {
    if (!kleur || !bron) return false;
    if (normaliseer(bron).indexOf(kleur) !== -1) return true;
    var woorden = kleurwoorden(bron);
    for (var i = 0; i < woorden.length; i++) {
      if (kleur.indexOf(woorden[i]) !== -1) return true;
    }
    return false;
  }

  function beeldPast(kleur, img) {
    if (!img) return false;
    return (
      past(kleur, img.getAttribute('alt')) ||
      past(kleur, img.getAttribute('src')) ||
      past(kleur, img.getAttribute('srcset'))
    );
  }

  function gekozenKleur(wortel) {
    var invoer = wortel.querySelectorAll('input[data-option-name]');
    for (var i = 0; i < invoer.length; i++) {
      var el = invoer[i];
      if (!OPTIE.test(el.getAttribute('data-option-name') || '')) continue;
      if (!el.checked) continue;
      var label = wortel.querySelector('label[for="' + el.id + '"]');
      var tekst = (label && label.textContent.trim()) || el.value || '';
      return normaliseer(tekst);
    }
    return '';
  }

  /* Op mobiel staan de miniaturen wel in de code maar zijn ze verborgen.
     Een klik erop doet dan niets, dus we moeten eerst controleren of ze
     daadwerkelijk zichtbaar zijn voordat we die route gebruiken. */
  function zichtbaar(el) {
    if (!el || !el.offsetParent) return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }

  function springNaarKleur(wortel) {
    var kleur = gekozenKleur(wortel);
    if (!kleur) return false;

    // 1. miniatuurbalk (desktop), alleen als die echt zichtbaar is
    var knoppen = wortel.querySelectorAll('.slideshow-controls__thumbnail');
    for (var i = 0; i < knoppen.length; i++) {
      if (!zichtbaar(knoppen[i])) break;
      if (!beeldPast(kleur, knoppen[i].querySelector('img'))) continue;
      if (knoppen[i].getAttribute('aria-selected') === 'true') return true;
      knoppen[i].click();
      return true;
    }

    /* 2. Op mobiel is de miniatuurbalk verborgen en staat het spoor op
       overflow: hidden, dus zelf scrollen werkt niet. De galerij is een
       slideshow-component met een eigen select(index). Die gebruiken we. */
    var component = wortel.querySelector('slideshow-component');

    /* Loopt de galerij vanzelf door, dan zetten we hem stil zodra iemand een
       kleur kiest. Anders schuift de gekozen kleur na een paar tellen weer weg. */
    if (component && component.autoplay && typeof component.pause === 'function') {
      try {
        component.pause();
      } catch (e) {
        /* niet erg, dan blijft hij lopen */
      }
    }

    if (component && typeof component.select === 'function') {
      var dias = component.querySelectorAll('slideshow-slide');
      for (var j = 0; j < dias.length; j++) {
        if (!beeldPast(kleur, dias[j].querySelector('img'))) continue;
        if (component.current === j) return true;
        try {
          component.select(j);
          return true;
        } catch (e) {
          /* valt hieronder terug op scrollIntoView */
        }
      }
    }

    // 3. laatste redmiddel voor galerijen zonder component (rasterweergave)
    var los = wortel.querySelectorAll('.product-media-container');
    for (var k = 0; k < los.length; k++) {
      if (!beeldPast(kleur, los[k].querySelector('img'))) continue;
      try {
        los[k].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      } catch (e) {
        los[k].scrollIntoView();
      }
      return true;
    }

    return false;
  }

  function koppel(wortel) {
    if (!wortel || wortel.dataset.norvelaKleurGekoppeld === 'ja') return;
    if (!wortel.querySelector('input[data-option-name]')) return;
    wortel.dataset.norvelaKleurGekoppeld = 'ja';

    wortel.addEventListener('change', function (e) {
      var doel = e.target;
      if (!doel || !doel.getAttribute) return;
      if (!OPTIE.test(doel.getAttribute('data-option-name') || '')) return;
      // Shopify werkt de galerij eerst zelf bij; daarna pas wij.
      setTimeout(function () {
        springNaarKleur(wortel);
      }, 90);
      setTimeout(function () {
        springNaarKleur(wortel);
      }, 400);
    });
  }

  function start() {
    var secties = document.querySelectorAll('.product-information, .shopify-section');
    for (var i = 0; i < secties.length; i++) koppel(secties[i]);
  }

  /* Hulp bij nakijken: typ norvelaKleurtest() in de console van de productpagina.
     Je krijgt dan te zien welke kleur gekozen is en welke foto's herkend worden. */
  window.norvelaKleurtest = function () {
    var wortel = document.querySelector('.product-information') || document;
    var kleur = gekozenKleur(wortel);
    var regels = [];
    var beelden = wortel.querySelectorAll(
      '.slideshow-controls__thumbnail img, slideshow-slide img'
    );
    for (var i = 0; i < beelden.length; i++) {
      regels.push({
        alt: beelden[i].getAttribute('alt'),
        bestand: (beelden[i].getAttribute('src') || '').split('/').pop().split('?')[0],
        match: beeldPast(kleur, beelden[i]),
      });
    }
    console.log('gekozen kleur (genormaliseerd):', kleur || '(geen kleuroptie gevonden)');
    console.table(regels);
    return { kleur: kleur, beelden: regels };
  };

  /* Zodra iemand zelf een maat of kleur aanklikt, moet de galerij stoppen met
     doorlopen. Anders springt hij naar de foto van die variant en schuift die
     een paar tellen later weer weg — dan lijkt het alsof je klik niets deed.
     Geldt voor elke optie, ook op een pagina zonder kleuren.

     Luisteraar op het document, want Shopify vervangt het koopblok bij een
     variantwissel en dan verdwijnt alles wat daaraan hing. */
  function stopDoorlopen() {
    var componenten = document.querySelectorAll('slideshow-component');
    for (var i = 0; i < componenten.length; i++) {
      var c = componenten[i];
      if (c.autoplay && typeof c.pause === 'function') {
        try {
          c.pause();
        } catch (e) {
          /* niet erg, dan blijft hij lopen */
        }
      }
    }
  }

  document.addEventListener('change', function (e) {
    if (e.target && e.target.getAttribute && e.target.getAttribute('data-option-name')) {
      stopDoorlopen();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', start);
})();
